module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_design.9bebf142.svg";